"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeedbackCallToAction() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return;
}
function FeedbackForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 rounded-lg" style={{
      backgroundColor: "var(--color-primary-light)"
    }}>
        <p className="font-semibold mb-4" style={{
        color: "var(--color-primary)"
      }}>
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="w-full">
          Submit Another Response
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-5">
        {}
        <FormField control={control} name="name" render={({
        field
      }) => <FormItem>
              <FormLabel>Your Name</FormLabel>
              <FormControl>
                <Input placeholder="Jane Doe" className="bg-background border-border focus-visible:ring-2 transition-all" style={{
            borderWidth: "1px",
            borderRadius: "var(--radius-sm)",
            borderColor: "var(--color-border)"
          }} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="email" rules={{
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jane@example.com" className="bg-background border-border focus-visible:ring-2 transition-all" style={{
            borderWidth: "1px",
            borderRadius: "var(--radius-sm)",
            borderColor: "var(--color-border)"
          }} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="parent_rating" rules={{
        required: "Please select a rating"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Your Rating</FormLabel>
              <FormControl>
                <div className="space-y-2">
                  {["1 – Poor", "2 – Fair", "3 – Good", "4 – Very Good", "5 – Excellent"].map((option, i) => <label key={i} data-index={i} className="flex items-center gap-3 p-3 rounded-md cursor-pointer transition-all hover:bg-muted" style={{
              borderRadius: "var(--radius-sm)"
            }}>
                      <input type="radio" value={option} checked={field.value === option} onChange={e => field.onChange(e.target.value)} className="size-4 accent-primary cursor-pointer" />
                      <span className="text-sm font-medium">{option}</span>
                    </label>)}
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="comments" rules={{
        required: "Please provide your feedback"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Your Feedback</FormLabel>
              <FormControl>
                <Textarea placeholder="What did you think about this review?" rows={4} className="bg-background border-border focus-visible:ring-2 transition-all resize-none" style={{
            borderWidth: "1px",
            borderRadius: "var(--radius-sm)",
            borderColor: "var(--color-border)"
          }} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 rounded-lg" style={{
        backgroundColor: "var(--color-accent-light)"
      }}>
            <p className="text-sm font-medium" style={{
          color: "var(--color-accent)"
        }}>
              {submitError}
            </p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full transition-all hover:scale-102" style={{
        backgroundColor: "var(--color-primary)",
        color: "var(--color-foreground-primary)",
        borderRadius: "var(--radius-md)"
      }}>
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Submitting...
            </> : "Submit Feedback"}
        </Button>
      </div>
    </Form>;
}